module.exports = __webpack_public_path__ + "media/src/application/media/no_logo-1b1ec71b90237de049aab1e554c71204.png";